module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book.079a6449.eot";